module.exports = __webpack_public_path__ + "img/Infografis_EN_15.8d86733b.jpg";